import React from "react";
import DOMPurify from 'dompurify';

function RecordingTile(props){

  const imageAlt = props.imageAlt !== false ? props.imageAlt : 'placeholder image for recording item';
  const imageSrc = props.imageUrl !== false ? props.imageUrl : '/wp-content/plugins/artsongs-blocks/images/midjourney-pink1.png';

  return (
    <a href={ `/${props.slug}` } role='button' className="tile recording">
      <picture>
        <img 
          src={ imageSrc }
          alt={ imageAlt }
          />
      </picture>
      <h2 dangerouslySetInnerHTML={{ __html:DOMPurify.sanitize(props.title) }} />
    </a>
  );
}

export default RecordingTile;